import { QueryClient } from "@tanstack/react-query";
import { fetchAccommodationsData } from "@/hooks/product-detail-page/accommodations/use-accommodations";

const prefetchAccommodations = (
  queryClient: QueryClient,
  packageId: string,
  packageDateId: string,
  neoId: string,
  currencyId:string,
  marketId:string
) => {
  queryClient.prefetchQuery({
    queryKey: ["ACCOMMODATIONS", neoId, packageId, packageDateId, currencyId, marketId],
    queryFn: fetchAccommodationsData(packageId, packageDateId, neoId, currencyId, marketId),
    staleTime: Infinity
  });
};

export default prefetchAccommodations;